import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewAppCategories from './viewRelatedAppCategories';
import tableComposeExperienceLiveUrls from './tableComposeExperienceLiveUrls';
import viewRelatedSportRoomPackages from './viewRelatedSportRoomPackages';
import { IconSize, IconType } from '../components/atoms/icon/icon';
import viewRelatedSportRoomTeams from './viewRelatedSportRoomTeams';
import viewRelatedSportRoomTags from './viewRelatedSportRoomTags';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'General',
  attributeName:'Content-general-values',
  fields: [
    {
      attributeName: 'id',
      helpText: 'Id of the Category.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      placeholder: 'Category name...',
      hidden:true
    },
    {
      attributeName: 'name',
      helpText: 'Title of the category.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Category name...',
    },
    {
      attributeName: 'countriesAvailable',
      helpText: 'List of countries like "US", "UK", insert a country and press enter.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      multiple:true,
      label: 'Countries Available',
      multiple:true,
      placeholder: 'Press enter to add Country available...',
    },
    {
      attributeName: 'channels',
      helpText:'List of channels separated by commas like "@channel1","@channel2", press enter when channel is typed',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      multiple:true,
      label: 'Channels',
      placeholder: 'Channels separated by commas...',
    },
    {
      attributeName: 'playlists',
      helpText: 'List of playlists separated by commas like "PL010101010101010","PL02020202020202", press enter when playlist is typed',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      multiple:true,
      label: 'Playlists',
      placeholder: 'Playlists separated by commas...',
    },
    {
      attributeName: 'videoIds',
      helpText: 'List of videoIds separated by commas lik "dQw4w9WgXcQ", "6uYNSrXbLqE", press enter when videoId is typed',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      multiple:true,
      label: 'Video IDs',
      placeholder: 'Video Ids separated by commas...',
    },
     
  ],
};
